/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoCarousel_interiorPhotos = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedInteriorsPhotoRelatedSearchLinks_interiorPhotos">;
    readonly " $refType": "SbRespInteriorsPhotoCarousel_interiorPhotos";
};
export type SbRespInteriorsPhotoCarousel_interiorPhotos$data = SbRespInteriorsPhotoCarousel_interiorPhotos;
export type SbRespInteriorsPhotoCarousel_interiorPhotos$key = {
    readonly " $data"?: SbRespInteriorsPhotoCarousel_interiorPhotos$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsPhotoCarousel_interiorPhotos">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsPhotoCarousel_interiorPhotos",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedInteriorsPhotoRelatedSearchLinks_interiorPhotos"
    }
  ],
  "type": "SearchBrowseInteriorPhotosModule",
  "abstractKey": null
};
(node as any).hash = 'dc0cb4304974ac08f47b5717f4be3b2c';
export default node;
